var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28_599)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 18C0 8.064 8.064 0 18 0C27.936 0 36 8.064 36 18C36 27.936 27.936 36 18 36C8.064 36 0 27.936 0 18ZM23.4035 10.7965C23.4035 13.7788 20.9859 16.1965 18.0035 16.1965C15.0212 16.1965 12.6035 13.7788 12.6035 10.7965C12.6035 7.81415 15.0212 5.39648 18.0035 5.39648C20.9859 5.39648 23.4035 7.81415 23.4035 10.7965ZM28.6651 24.0479C28.9805 25.6333 28.8034 26.3525 28.8034 26.3525C28.8034 28.4704 23.4035 29.5293 18.0035 29.6088C12.6035 29.5293 7.20381 28.4704 7.20381 26.3525C7.20381 26.3525 7.02679 25.6333 7.34216 24.0479C7.91029 21.1917 10.143 18.959 12.9992 18.3909C14.3753 18.1171 16.1971 17.9872 18.0035 17.9883C19.8098 17.9872 21.632 18.1171 23.0081 18.3909C25.8643 18.959 28.097 21.1917 28.6651 24.0479Z",
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28_599"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.304bcc824b053e1913dbad4c73db8df7.svg";
export { ForwardRef as ReactComponent };